"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultFilterTypes = void 0;
const dateUtils_1 = require("./dateUtils");
const getDefaultFilterTypes = () => ({
    entityid: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? String(rowValue)
                    .toLowerCase()
                    .startsWith(String(filterValue).toLowerCase())
                : true;
        });
    },
    string: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? String(rowValue)
                    .toLowerCase()
                    .startsWith(String(filterValue).toLowerCase())
                : true;
        });
    },
    daterange: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            if (rowValue == null)
                return true;
            const filterHasStartDate = filterValue.startDate != null;
            const filterHasEndDate = filterValue.endDate != null;
            if (filterHasStartDate && filterHasEndDate) {
                return (0, dateUtils_1.isSameDayOrBetween)(rowValue, filterValue.startDate, filterValue.endDate);
            }
            if (filterHasStartDate) {
                return (0, dateUtils_1.isSameDayOrAfter)(rowValue, filterValue.startDate);
            }
            if (filterHasEndDate) {
                return (0, dateUtils_1.isSameDayOrBefore)(rowValue, filterValue.endDate);
            }
            return true;
        });
    },
    singleselect: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase()
                : true;
        });
    },
    multiselect: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined && filterValue.length > 0
                ? filterValue.some((filterSelection) => String(rowValue).toLowerCase() ===
                    String(filterSelection.value).toLowerCase())
                : true;
        });
    },
    singleselecttypeahead: (rows, id, filterValue) => {
        return rows.filter((row) => {
            const rowValue = row.values[id];
            return rowValue !== undefined
                ? String(rowValue).toLowerCase() === String(filterValue).toLowerCase()
                : true;
        });
    }
});
exports.getDefaultFilterTypes = getDefaultFilterTypes;
exports.default = exports.getDefaultFilterTypes;
//# sourceMappingURL=getDefaultFilterTypes.js.map